import axiosInstance from "../config/axiosInterceptor";

export async function getDashboardWidgets(projectName = null) {
  const params = projectName ? { projectName } : {};
  return await axiosInstance.get("/api/Dashboard/GetDashboardWidgets", { params });
}

export async function getOnlineNodeWidget() {
  return await axiosInstance.get("/api/Dashboard/GetOnlineNodeWidget");
}

export async function getListById(listId, nodeId = null) {
  const url = nodeId
    ? `/api/Dashboard/GetListById/${listId}/${nodeId}`
    : `/api/Dashboard/GetListById/${listId}`;
  return await axiosInstance.get(url);
}

export async function getVendaiTimePeriodSaleTable(periodId = 3) {
  const url = `/api/Dashboard/VendaiTimePeriodSaleTable/${periodId}`;
  try {
    // returnCode === 0 → interceptor zaten içteki data objesini döndürür
    return await axiosInstance.get(url);
  } catch (err) {
    // Backend returnCode !== 0 (örn. -1) dönse de data dolu olabilir;
    // interceptor reddediyor — response gövdesinden veriyi kurtar.
    const body = err?.response?.data;
    if (body && body.data) {
      return body.data;
    }
    throw err;
  }
}
